export default {"src":"/_next/static/media/SubDesc4.9215f4ab.svg","height":121,"width":120,"blurWidth":0,"blurHeight":0};